import { IconButton, Tooltip } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { BsThreeDotsVertical } from 'react-icons/bs';

import ActionMenu from 'components/presentational/ActionMenu';
import ActionsCellWrapper from './ActionsCellWrapper';

/**
 * Standard AG Grid "Action" column cell. Renders a single inline kebab
 * IconButton when only one action applies to the row, or an ActionMenu
 * dropdown when multiple actions apply — so callers don't need to branch
 * on action count themselves.
 *
 * @param {object}   params
 * @param {Array}    params.actions      [{ label, icon, onClick, isVisible, isDisabled, dataAttributes }]
 * @param {string}   [params.menuLabel]  Tooltip label for the trigger when multiple actions render.
 */
const ActionsButton = ({ actions = [], menuLabel }) => {
    const { darkMode } = useSelector((state) => state.settings);
    const visibleActions = actions.filter((action) => action.isVisible ?? true);

    if (visibleActions.length === 0) return null;

    if (visibleActions.length === 1) {
        const [action] = visibleActions;
        return (
            <ActionsCellWrapper>
                <Tooltip label={action.label}>
                    <IconButton
                        icon={
                            <BsThreeDotsVertical
                                fill={darkMode ? 'white' : 'black'}
                            />
                        }
                        aria-label={action.label}
                        variant="ghost"
                        isDisabled={action.isDisabled}
                        onClick={action.onClick}
                        _hover={{
                            bg: darkMode ? 'whiteAlpha.200' : 'blackAlpha.100',
                        }}
                        _active={{
                            bg: darkMode ? 'whiteAlpha.300' : 'blackAlpha.200',
                        }}
                        _focus={{ boxShadow: 'none' }}
                        {...(action.dataAttributes || {})}
                    />
                </Tooltip>
            </ActionsCellWrapper>
        );
    }

    return (
        <ActionsCellWrapper>
            <ActionMenu actionItems={visibleActions} menuLabel={menuLabel} />
        </ActionsCellWrapper>
    );
};

export default ActionsButton;
